import * as yup from 'yup';

import { PayInternalInvoiceFields } from '../../PayInternalInvoiceForm.types';

export const payInternalInvoiceFormSchema = yup.object({
  [PayInternalInvoiceFields.ACCOUNT_ID]: yup.string()
});
